import { useMutation } from '@apollo/client/react';
import { Stack } from '@mui/material';

import { type ReportComponentProps } from '@modules/_shared/components/report-editor/ReportEditorContext';
import { ListingDocuments } from '@modules/listings/ListingDocuments';
import { UPDATE_BROCHURE_REPORT_FILE } from '@modules/reports/brochure-report/brochureReportsQueries';
import { FooterActionsComponentWithoutForm } from '@modules/reports/shared/FooterActionsComponentWithoutForm';
import { useLocale } from '@shared/hooks/locale';

const StepAppendFilesBrochure = (props: ReportComponentProps) => {
  const { reportId: listingId } = props;
  const { t } = useLocale();

  const [updateListing] = useMutation(UPDATE_BROCHURE_REPORT_FILE);

  return (
    <Stack
      sx={{
        flexGrow: 1,
        height: '0',
      }}
    >
      <ListingDocuments
        lotId={listingId}
        hideColumns={[
          'document_type',
          'uploader',
          'created',
          'display_on_listing',
        ]}
        acceptedMimetypes={['application/pdf']}
        acceptLabel={t('PDF files')}
        onUpdate={() => {
          updateListing({
            variables: {
              id: listingId,
              input: {
                updated_at: new Date().toISOString(),
              },
            },
          });
        }}
      />
      <FooterActionsComponentWithoutForm
        {...props}
        saveLabel={t('Share report')}
        updating={false}
      />
    </Stack>
  );
};

export default StepAppendFilesBrochure;
